findLoanOfficerButton = document.querySelector('.find-loan-officer button');
if (findLoanOfficerButton != null) {
  findLoanOfficerButton.addEventListener('click', (e) => {
    selectedOption = document.querySelector('.find-loan-officer select[name=\'stateOption\']');
    if (selectedOption != null && selectedOption.value != '') {
      window.location.href = selectedOption.value;
    }
  });
}
